// Meta
export const name = "gvNotice";

// Props
export const schemes = ["info", "success", "warning", "error"] as const;
export const sizes = ["sm", "md", "lg"] as const;
